import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import React, { useRef } from "react";
import PropTypes from "prop-types";

// PassPay payments registry table
// Columns are based on the attached mockup (reest.jpg)
const PassPayTable = ({ page, pageSize, onPageChange, data, totalItems }) => {
  const tableRef = useRef();

  const indexTemplate = (_rowData, { rowIndex }) => {
    // Show sequential number taking into account paginator page offset when available
    try {
      const currentPage = page || 0;
      const rows = pageSize || 10;
      return currentPage * rows + rowIndex + 1;
    } catch (e) {
      return rowIndex + 1;
    }
  };

  const dateTimeTemplate = (rowData, field) => {
    const value = rowData?.[field];
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleString();
  };

  const paymentIdTemplate = (rowData) => rowData?.paymentId ?? rowData?.id ?? "";
  return (
      <div className="card">
        <DataTable
            ref={tableRef}
            value={data}
            className="p-datatable-customers"
            dataKey="id"
            rowHover
            emptyMessage="Данные не найдены"
            scrollable
        >
          <Column headerStyle={{ width: "80px" }} header="№" body={indexTemplate} />
          <Column
              headerStyle={{ width: "180px" }}
              field="paymentId"
              header="ID платежа"
              body={paymentIdTemplate}
              sortable
          />
          <Column
              headerStyle={{ width: "200px" }}
              field="recipientIin"
              header="ИИН получателя"
              sortable
          />
          <Column
              headerStyle={{ width: "240px" }}
              field="recipientName"
              header="Наименование получателя"
              sortable
          />
          <Column
              headerStyle={{ width: "160px" }}
              field="recipientKbe"
              header="Кбе получателя"
              sortable
          />
          <Column
              headerStyle={{ width: "220px" }}
              field="paymentDate"
              header="Дата платежа"
              // body={(rowData) => dateTimeTemplate(rowData, "paymentDate")}
              sortable
          />
          <Column
              headerStyle={{ width: "160px" }}
              field="amount"
              header="Сумма"
              sortable
          />
          <Column
              headerStyle={{ width: "120px" }}
              field="currency"
              header="Валюта"
              sortable
          />
          <Column
              headerStyle={{ width: "200px" }}
              field="bankCommissionAmount"
              header="Сумма комиссии банка"
              sortable
          />
          <Column
              headerStyle={{ width: "220px" }}
              field="recipientPhone"
              header="Номер телефона получателя"
              sortable
          />
          <Column
              headerStyle={{ width: "220px" }}
              field="email"
              header="E-mail"
              sortable
          />
          <Column
              headerStyle={{ width: "160px" }}
              field="contractNumber"
              header="Номер договора"
              sortable
          />
          <Column
              headerStyle={{ width: "220px" }}
              field="contractDate"
              header="Дата договора"
              body={(rowData) => dateTimeTemplate(rowData, "contractDate")}
              sortable
          />
          <Column
              headerStyle={{ width: "180px" }}
              field="referenceNumber"
              header="Референс номер"
              sortable
          />
        </DataTable>
        <Paginator
            currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            first={page * pageSize}
            rows={pageSize}
            totalRecords={totalItems}
            rowsPerPageOptions={[10, 25, 50, "все"]}
            onPageChange={onPageChange}
        />
      </div>
  );
};

PassPayTable.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  totalItems: PropTypes.number.isRequired,
};

export default PassPayTable;
